var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointOfInterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2058 16.5183C21.8058 13.0909 21.9456 7.39409 18.5182 3.79417C15.0908 0.194243 9.39406 0.054383 5.79413 3.48178C2.19421 6.90918 2.05435 12.6059 5.48175 16.2059L11.6876 22.7241L18.2058 16.5183ZM6.93024 14.8268L11.757 19.8965L16.8268 15.0698C19.6267 12.404 19.7355 7.97318 17.0697 5.17324C14.404 2.3733 9.97315 2.26452 7.17321 4.93028C4.37327 7.59603 4.26449 12.0268 6.93024 14.8268Z",
    fill: "#7E8A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86988 7.39342C9.34814 7.07411 9.92956 6.9422 10.5009 7.02337C11.0722 7.10455 11.5924 7.39301 11.9603 7.83254C12.3294 7.39493 12.8495 7.1079 13.4202 7.02681C13.9908 6.94573 14.5717 7.07632 15.0507 7.39342C15.3328 7.58488 15.5655 7.83897 15.7304 8.13532C15.8953 8.43167 15.9876 8.76206 16 9.10002C16 10.6469 14.6669 11.8944 12.546 13.7907C12.3971 13.9253 12.2025 14 12.0007 14C11.7988 14 11.6042 13.9253 11.4553 13.7907C9.33445 11.8944 7.95084 10.6469 8.00134 9.10002C8.00443 8.76887 8.08434 8.44283 8.23491 8.14697C8.38548 7.85111 8.6027 7.59332 8.86988 7.39342Z",
    fill: "#7E8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointOfInterest);
export default __webpack_public_path__ + "static/media/point-of-interest.0939e579.svg";
export { ForwardRef as ReactComponent };